'use strict';
const angular = require('angular');

export class NotificationMessagesComponent {
  menu = [{
    title: 'Home',
    url: 'main'
  }];

  isCollapsed = true;

  constructor($state, $scope, $rootScope, fetch, lookup) {
    'ngInject';

    this.$state = $state;
    this.$scope = $scope;
    this.fetch = fetch;


   

  }

  $onInit(){
    // this.getJurisdictionList();
    // this.getStationAreaList();
  }

  // getJurisdictionList(){
  //   this.fetch.getAllItems('api/data/jurisdictions/list')
  //   .then(response => {
  //     
  //     this.$scope.jurisdictions = response.data;
  //     this.$scope.jurisdiction = response.data[0].jurisdiction;
  //     this.getStationAreaList(this.$scope.jurisdiction);
  //   })
  //   .catch(err => {
  //     console.log(err);
  //   })
  // }

  // getStationAreaList(jurisdiction){
  //   console.log(`api/data/stationareas/${jurisdiction}`);
  //   this.fetch.getAllItems(`api/data/stationareas/${jurisdiction}`)
  //   .then(response => {
  //     
  //     this.$scope.stationAreas = response.data;
  //   })
  //   .catch(err => {
  //     console.log(err);
  //   })
  // }
}


export default angular.module('appApp.notificationmessages', [])
  .directive('notificationmessages', function() {
    return {
      template: require('./notificationmessages.html'),
      restrict: 'EA',
      controller: NotificationMessagesComponent,
      controllerAs:'notificationMessagesCtrl',
      link: function(scope, element, attrs) {}
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/notificationmessages/notificationmessages.directive.js